import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export interface ScrollSentinelClasses {
	/** styles applied to the root element */
	root: string;
}

export const getSentinelUtilityClass = (slot: string) =>
	generateUtilityClass('Sentinel', slot);

export const scrollSentinelClasses = generateUtilityClasses<
	keyof ScrollSentinelClasses
>('Sentinel', ['root']);
export default scrollSentinelClasses;
